import React, { Component, Fragment } from 'react';
import { Button, Grid, Dropdown } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { reset } from 'redux-form';

import { Filter, Main } from 'Containers';
import ReimbursementRatesForm from './components/ReimbursementRatesForm';
import { REIMBURSEMENT_RATE_FORM } from 'Common/FormEnum';
import {
  getReimbursementRates,
  setReimbursementRate,
  writeReimbursementRate,
  setFormDataById,
  clearFormData,
  setSuccess,
  setCancelChange,
  clearError,
} from './state/rates/actions';

import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { DirtyWrapper, LoadingPage } from 'Components';
import { createToast, toastType, errorToast } from 'Common/ToastHelper';
import { submitDelay } from 'Common/GeneralHelper';
import { resetDirty } from 'State/dirtyTracking/actions';

class ReimbursementRatesContainer extends Component {
  constructor(props) {
    super(props);
    this.ddRate = React.createRef();
  }

  state = {
    selectedReimbursementRate: 0,
    formData: {},
  };

  getMainProps = () => {
    const { isReadOnly } = this.props;

    return {
      toolbox: {
        isReadOnly,
        formName: REIMBURSEMENT_RATE_FORM,
        saveButtonProps: {
          content: 'Save',
          disabled: false,
          loading: false,
        },
        shown: true,
      },
    };
  };

  componentDidMount() {
    this.props.getReimbursementRates();
  }

  componentDidUpdate(prevProps) {
    if (errorToast(this.props, prevProps, 'fetchError')) {
      this.props.clearError();
    }

    if (prevProps.success === false && this.props.success === true) {
      createToast(
        toastType.success,
        null,
        'Success: Reimbursement Rate saved',
        true,
        2500
      );
      this.props.setSuccess(false);
      this.props.resetDirty();
    }
  }

  submitForm = values => {
    return submitDelay().then(() => {
      this.props.writeReimbursementRate(values);
    });
  };

  confirmChange = () => {
    const { selectedReimbursementRate } = this.state;
    this.props.setReimbursementRate(selectedReimbursementRate);
    this.props.setCancelChange(false);
    //document.getElementById('ddRate').focus();
    this.ddRate.current.handleFocus();
    this.props.resetDirty();
  };

  confirmNew = () => {
    this.props.clearFormData();
    this.props.reset(REIMBURSEMENT_RATE_FORM);
  };

  confirmNoChange = () => {
    this.props.setCancelChange(true);
  };

  getFormValues = () => {
    const rates = this.props.reimbursementRateList;
    return rates
      ? rates.find(x => x.Id === this.props.selectedReimbursementRate)
      : {};
  };

  render() {
    if (this.props.fetching) return <LoadingPage message={'loading'} />;

    const options = this.props.reimbursementRateList.map(element => {
      return {
        value: element.Id,
        text: element.Description,
      };
    });

    return (
      <Fragment>
        <Filter title={'Reimbursement Rates'}>
          <Grid>
            <Grid.Row columns={3}>
              <Grid.Column width="6" floated="left">
                <DirtyWrapper
                  closeModalYesCallback={this.confirmChange}
                  closeModalNoCallback={this.confirmNoChange}
                >
                  {showDirtyConfirm => (
                    <Dropdown
                      id="ddRate"
                      ref={this.ddRate}
                      placeholder="Reimbursement Rate"
                      fluid
                      selection
                      options={options}
                      onMouseDown={() => {
                        this.setState(showDirtyConfirm);
                      }}
                      onKeyDown={() => {
                        this.setState(showDirtyConfirm);
                      }}
                      onChange={(e, data) => {
                        if (!this.props.cancelChange) {
                          const id = data.value;
                          this.setState({
                            selectedReimbursementRate: id,
                          });
                          this.props.setFormDataById(id);
                          this.props.setReimbursementRate(id);
                        }
                      }}
                      value={this.props.selectedReimbursementRate}
                      disabled={this.props.fetching}
                    />
                  )}
                </DirtyWrapper>
              </Grid.Column>
              <Grid.Column floated={'right'} textAlign={'right'}>
                <DirtyWrapper closeModalYesCallback={this.confirmNew}>
                  {showDirtyConfirm => (
                    <Button
                      onClick={() => {
                        this.setState(showDirtyConfirm);
                      }}
                      disabled={this.props.isReadOnly}
                    >
                      Add Reimbursement Rate
                    </Button>
                  )}
                </DirtyWrapper>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>{' '}
        <Main {...this.getMainProps()}>
          <ReimbursementRatesForm
            onSubmit={this.submitForm}
            initialValues={this.props.formData}
            isFetching={this.props.fetching}
            isReadOnly={this.props.isReadOnly}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty(REIMBURSEMENT_RATE_FORM)(state));

  const { rates } = state.ReimbursementRatesState;

  return {
    reimbursementRateList: rates.reimbursementRates,
    fetching: rates.fetching,
    fetchError: rates.fetchError,
    selectedReimbursementRate: rates.selectedReimbursementRate,
    success: rates.success,
    formData: rates.formData,
    cancelChange: rates.cancelChange,
  };
};

export const ReimbursementRates = withRouter(
  connect(
    mapStateToProps,
    {
      getReimbursementRates,
      setReimbursementRate,
      writeReimbursementRate,
      resetDirty,
      setFormDataById,
      clearFormData,
      reset,
      setSuccess,
      setCancelChange,
      clearError,
    }
  )(ReimbursementRatesContainer)
);



// WEBPACK FOOTER //
// ./src/pages/reimbursementrates/ReimbursementRates.js